var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"max-height":"18","max-width":"18","src":"/img/icons/allproducts.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }